import { VITE_FACEBOOK_APP_ID } from "@/config/constants.js";
import type { AppContext } from "vue";

interface FbInstance {
  init: (params: { appId: string; xfbml: boolean; version: string }) => void;
  ui: (
    options: {
      method: string;
      href: string;
    },
    fn: (res: unknown) => void,
  ) => void;
}
let fbInstance: FbInstance | null = null;

const fetchFbInstance = async () => {
  if (fbInstance) {
    return fbInstance;
  }
  return new Promise<FbInstance>((resolve, reject) => {
    window.fbAsyncInit = function () {
      fbInstance = window.FB as FbInstance;
      if (fbInstance) {
        fbInstance.init({
          appId: VITE_FACEBOOK_APP_ID,
          xfbml: true,
          version: "v19.0",
        });
        resolve(fbInstance);
      }
    };
    (function (d, s, id) {
      const fjs = d.getElementsByTagName(s)[0] as HTMLScriptElement;
      if (d.getElementById(id)) {
        return;
      }
      const js = d.createElement(s) as HTMLScriptElement;
      js.id = id;
      js.src = "https://connect.facebook.net/es_ES/sdk.js";
      js.onerror = () => reject("fb script not loaded");
      fjs.parentNode?.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  });
};

export { fetchFbInstance };

export default {
  install: (app: AppContext) => {
    fetchFbInstance()
      .then((fb) => (app.config.globalProperties.$fb = fb))
      .catch((error) => console.error(error));
  },
};
